<template>
    <el-container>
        <el-header>
            <el-form :inline="true" class="demo-form-inline" :model="fromDept" ref="fromDept">
                <el-form-item>
                    <td-button type="button" @click="btnAddDevice"> {{ $t('common.ADD') }}</td-button>
                    <td-button type="button" @click="btnDeleteBatch">{{ $t('common.DELETE_BATCH') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <td-table :columns="columns" :dataSource="tableData" :height="300" :hasPage="false" ref="listDept"></td-table>
            <dialogOrgTree
                v-if="dlalogOrgTreeVisible"
                :title="title"
                :dialogOrgVisible="dlalogOrgTreeVisible"
                :checkStrictly="true"
                :checkNodes="checkNodes"
                @orgDialogClose="dlalogTreeClose"
                @selected="selected"
                ref="dialogOrgTree"
            ></dialogOrgTree>
        </el-main>
    </el-container>
</template>
<script>
import dialogOrgTree from './dialogOrgTree.vue';
export default {
    components: { dialogOrgTree },
    props: {
        editItem: {
            trpe: Object,
            default: function() {
                return null;
            }
        }
    },
    data() {
        return {
            tableData: [],
            dlalogOrgTreeVisible: false,
            fromDept: {},
            orgTreeids: [],
            checkNodes: [],
            columns: [
                {
                    prop: 'orgName',
                    label: 'common.BELONGED_DEPT',
                    align: 'center'
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDeleteBatch(params.row.orgId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    mounted() {},

    created() {
        // 为编辑状态则进行初始化数据
        this.init();
    },
    methods: {
        // 数据初始化设备所属组织
        init() {
            let param = {
                sId: this.editItem.sId
            };

            window.pgApi.queryDeviceOrg(param, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/queryOrgByDeviceId', response);
                    this.$message({
                        showClose: true,
                        message: this.$t('error.ERROR_RESPONSE'),
                        type: 'error'
                    });
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('/device/queryOrgByDeviceId', response.data.statusMessage);
                    return;
                }

                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddDevice() {
            this.$log.info('btnAddDevice');
            this.dlalogOrgTreeVisible = true;
            this.title = 'common.SELECT_ORG'; // 标题
        },
        // 组织树形回调
        selected(node) {
            this.orgTreeids = [];
            node.forEach(val => {
                this.orgTreeids.push(val.id);
            });
            let param = {
                sId: this.editItem.sId,
                sOrgIdArray: this.orgTreeids
            };
            window.pgApi.addDeviceOrg(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({
                        showClose: true,
                        message: this.$t('error.ERROR_RESPONSE'),
                        type: 'error'
                    });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('/device/addDeviceOrg', response.data.statusMessage);
                    return;
                }
                this.$message({
                    showClose: true,
                    message: response.data.statusMessage,
                    type: 'success'
                });
                this.submit();
            });
        },
        // 删除
        btnDeleteBatch(id) {
            this.$log.info('btnDeleteBatch');
            let ids = [];
            if (id) {
                ids.push(id);
            } else {
                ids = this.getKeys();
            }
            if (ids.length === 0) {
                this.$message({
                    showClose: true,
                    message: this.$t('common.PLEASE_SELECT'),
                    type: 'warning'
                });
                return;
            }
            let param = {
                sId: this.editItem.sId,
                sOrgIdArray: ids
            };
            this.$confirm(this.$t('pgCommon.DELETE_DEVICE_ORG'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    window.pgApi.deleteDeviceOrg(JSON.stringify(param), response => {
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$message({
                                showClose: true,
                                message: this.$t('error.ERROR_RESPONSE'),
                                type: 'error'
                            });
                            this.$log.error('/device/deleteDeviceOrg', response);
                            return;
                        }
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({
                                showClose: true,
                                message: response.data.statusMessage,
                                type: 'error'
                            });
                            this.$log.error('/device/deleteDeviceOrg', response.data.statusMessage);
                            return;
                        }
                        this.$message({
                            showClose: true,
                            message: response.data.statusMessage,
                            type: 'success'
                        });
                        this.submit();
                    });
                })
                .catch(e => {
                    this.$log.error('/device/deleteDevice', e);
                });
        },
        getKeys() {
            let ids = this.$refs.listDept.getSelectAllRows();
            let keys = [];
            for (let i = 0; i < ids.length; i++) {
                let temValue = ids[i];
                let id = temValue.orgId;
                keys.push(id);
            }
            return keys;
        },

        submit() {
            this.init();
            this.$emit('change', true);
        },
        dlalogTreeClose() {
            this.$log.info('dlalogTreeClose');
            this.dlalogOrgTreeVisible = false;
        }
    }
};
</script>
<style></style>
